<div class="tree-item" [ngClass]="{
  'tree-item--root': depth === 0,
  'tree-item--no-children': !element.options || element.options.length === 0
}">
  <button #contentButton class="tree-item__content" (click)="selectElement()">
    <div class="tree-item__controls">
      <button class="tree-item__button" (click)="toggleExpanded($event)" *ngIf="element.options && element.options.length">
        <i [ngClass]="element.expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
      </button>
      <button class="tree-item__button tree-item__button--delete" (click)="deleteElement($event)" *ngIf="depth !== 0">
        <i class="pi pi-trash"></i>
      </button>
    </div>
    <div class="tree-item__label">
      {{ element.label }}
    </div>
    <div class="tree-item__actions">
      <button class="tree-item__button tree-item__button--add" (click)="addSubset($event)">
        <i class="pi pi-plus"></i>
      </button>
    </div>
  </button>
  <div class="tree-item__children" *ngIf="element.expanded && element.options && element.options.length">
    <app-scenario-tree
      *ngFor="let child of element.options"
      [element]="child"
      [depth]="depth + 1"
      [animations]="animations" 
      [selectedElement]="selectedElement"
      (elementSelected)="onElementSelected($event)"
      (elementDeleted)="onElementDeleted($event)">
    </app-scenario-tree>
  </div>
</div>